<template>
    <nav>
        <ul class="container">
            <li
                class="route"
                v-for="(route, index) in routes"
                :key="index"
            >
                <router-link
                    class="link"
                    :class="{'active' : $route.path === route.link[0]}"
                    :to="route.link[0]"
                    v-if="route.link.length === 1"
                    @click.native="changeTab()"
                >
                    <img v-if="route.icon" :src="route.icon">
                
                    
                    {{route.label}}
                    
                </router-link>

                <div
                    v-else
                    class="link"
                    @click="showSub = !showSub"
                    :class="{'active' : route.link.some(i => i.link === $route.path)}"
                >
        
                    <img v-if="route.icon" :src="route.icon">

                    {{route.label}}

                    <img src="@/assets/img/icon/angle-down.svg" class="arrow" :class="{'up' : showSub}">

                    <ul v-if="showSub">
                        <li v-for="(sublink, index) in route.link" :key="index">
                            <router-link :to="sublink.link">
                                {{ sublink.label }}
                            </router-link> 
                        </li>
                    </ul>
                </div>
            </li>
        </ul>    
    </nav>
</template>

<script>
import { mapFields } from 'vuex-map-fields'

export default {
    data () {
        return {
            showSub: false
        }
    },

    methods: {
        changeTab () {
            this.showSub = false
        }
    },

    computed: {
        ...mapFields('auth', ['user']),
        routes () {
            if (this.user.role === 'admin') {
				return [
					// { label: 'Dashboard', link: ['/dashboard'], icon: require('@/assets/img/icon/signal-alt.svg') },
					// { label: 'Distributor', link: ['/distributor'], icon: require('@/assets/img/icon/user-square.svg') },
					{ label: 'Insight Account', link: [
                        {label: 'Account Request', link: '/account-request'},
                        {label: 'Registered Account', link: '/registered-accounts'},
                    ], icon: require('@/assets/img/icon/window.svg') },
					{ label: 'Router', link: ['/router-list'], icon: require('@/assets/img/icon/server-alt.svg') },
                    { label: 'Notification', link: ['/notification-post']},
                    { label: 'Users', link: ['/users']}
				]
			}

			return [
				// { label: 'Dashboard', link: ['/dashboard'], icon: require('@/assets/img/icon/Dashboard.svg') },
				{ label: 'Registered Accounts', link: ['/registered-accounts'], icon: require('@/assets/img/icon/Archives.svg') }
			]
        }
    }
}
</script>

<style lang="scss" scoped>
nav {
    background-color: #fff;
    box-shadow: 0 2px 6px #0000000A;

    ul {
        display: flex;
        align-items: center;
        list-style: none;
    }

    .route {
        cursor: pointer;

        &:not(:first-child) {
            margin-left: 40px;
        }

        .link {
            display: inline-block;
            border-bottom: 2px solid transparent; 
            padding: 10px 5px 20px 0;
            transition: 0.3s;

            input[type=radio] {
                appearance: none;
            }

            img {
                width: .8rem;
                margin-right: 0.5rem;
                transition: 0.3s;
                filter: grayscale(1);
            }

            position: relative;

            ul {
                position: absolute;
                z-index: 9;
                background-color: #fff;
                top: 100%;
                left: 0;
                margin-top: .5rem;
                display: inline-block;
                box-shadow: 0 0 20px #7783951A;

                li {
                    text-align: center;
                    &:hover {
                        a {
                            background: #2DC4B6;
                            color: #fff;
                        }
                    }

                    a {
                        padding: 10px;
                        width: 150px;
                        font-size: .9rem;
                        display: block;
                        transition: 0.3s;
                    }
                }
            }

            &.active {
                border-color: #2DC4B6;
                color: #2DC4B6;
    
                img {
                    filter: none;
                }
            }

            .arrow {
                margin-left: 10px;
                transform: scale(-1);

                &.up {
                    transform: scale(1);
                }
            }
        }
        
    }
}
</style>